module.exports = "img/9.8876c9.jpg";